(() => {
  const merge = (base, extra, productURL) => {
    const same = (a, b) => JSON.stringify(a) === JSON.stringify(b);
    const unique = values => [...new Map(values.map(value => [JSON.stringify(value), value])).values()];
    let identity;
    try { identity = new URL(extra['@id'], productURL).href; } catch { return null; }
    if (base['@type'] !== 'Product' || extra['@type'] !== 'Product' || base.name !== extra.name || identity !== productURL + '#product' || !Array.isArray(base.offers) || (!extra.aggregateRating && !extra.review)) return null;
    const result = JSON.parse(JSON.stringify(base));
    for (const [key, value] of Object.entries(extra)) {
      if (['@context', '@id'].includes(key)) continue;
      if (key === 'image' || key === 'review') {
        const array = item => item == null ? [] : Array.isArray(item) ? item : [item];
        result[key] = unique([...array(result[key]), ...array(value)]);
      } else if (key === 'aggregateRating') result[key] = value;
      else if (result[key] === undefined) result[key] = value;
      else if (!same(result[key], value)) return null;
    }
    result['@id'] = productURL + '#product';
    return result;
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = merge;
  if (typeof document === 'undefined') return;
  const consolidate = () => {
    const owned = document.getElementById('hadaya-product-schema');
    if (!owned) return;
    let base;
    try { base = JSON.parse(owned.textContent); } catch { return; }
    const productURL = owned.dataset.productUrl;
    for (const script of document.querySelectorAll('script[type="application/ld+json"]')) {
      if (script === owned) continue;
      let extra;
      try { extra = JSON.parse(script.textContent); } catch { continue; }
      if (!extra || typeof extra !== 'object') continue;
      const merged = merge(base, extra, productURL);
      if (!merged) continue;
      owned.textContent = JSON.stringify(merged);
      script.remove();
      base = merged;
    }
  };
  const boot = () => {
    consolidate();
    let queued = false;
    new MutationObserver(records => {
      const selector = 'script[type="application/ld+json"]';
      const relevant = records.some(record => {
        if (record.target.matches?.(selector)) return record.target.id !== 'hadaya-product-schema';
        return [...record.addedNodes].some(node => node.matches?.(selector) || node.querySelector?.(selector));
      });
      if (!relevant) return;
      if (queued) return;
      queued = true;
      queueMicrotask(() => { queued = false; consolidate(); });
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
